import { render, staticRenderFns } from "./DashboardEnrollmentPlan.vue?vue&type=template&id=b2fb84a8"
import script from "./DashboardEnrollmentPlan.vue?vue&type=script&lang=js"
export * from "./DashboardEnrollmentPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports